import { API_CONSTANTS } from "../../constants/apiConstants";
import baseApi from "./baseApiService";
export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserInfo: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_USER_INFO}`,
        method: "GET",
        headers: {
          "Content-Type": "*/*",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    getDetailsBySubscriptionId: builder.query({
      query: (subscriptionId) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_DETAILS_BY_SUBSCRIPTION_ID}${subscriptionId}`,
        method: "GET",
        headers: {
          "Content-Type": "*/*",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    registerSetPassword: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.REGISTER_SET_PASSWORD}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
  }),
});
export const {
  useLazyGetUserInfoQuery,
  useGetDetailsBySubscriptionIdQuery,
  useLazyRegisterSetPasswordQuery,
} = userApi;
